import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ILicenseEmployer } from 'app/models/licenses/license-employer';
import { IEmployer } from 'app/models/licenses/employer';

@Injectable({ providedIn: 'root' })
export class LicenseEmployerService {
  private api: string = environment.privateApi + 'Employer/';

  private http = inject(HttpClient);

  public createLicenseEmployer(licenseEmployer: ILicenseEmployer): Observable<ILicenseEmployer> {
    return this.http.post<ILicenseEmployer>(this.api + 'CreateLicenseEmployer', licenseEmployer);
  }

  public getEmployers(): Observable<IEmployer[]> {
    return this.http.get<IEmployer[]>(this.api + 'GetEmployers');
  }

  public getLicenseEmployers(licenseId: number): Observable<ILicenseEmployer[]> {
    return this.http.get<ILicenseEmployer[]>(this.api + 'GetLicenseEmployers/' + licenseId);
  }

  public updateLicenseEmployer(licenseEmployer: ILicenseEmployer): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateLicenseEmployer', licenseEmployer);
  }

  public deleteLicenseEmployer(licenseEmployerId: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'DeleteLicenseEmployer/' + licenseEmployerId);
  }
}
